'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBreakpointMapping = exports.assocQuery = exports.assocValue = exports.lQuery = exports.lName = exports.propQuery = exports.propValue = exports.propName = undefined;

var _ramda = require('ramda');

var propName = exports.propName = (0, _ramda.prop)('name');
var propValue = exports.propValue = (0, _ramda.prop)('value');
var propQuery = exports.propQuery = (0, _ramda.prop)('query');
var lName = exports.lName = (0, _ramda.lensProp)('name');
var lQuery = exports.lQuery = (0, _ramda.lensProp)('query');
var assocValue = exports.assocValue = (0, _ramda.assoc)('value');
var assocQuery = exports.assocQuery = (0, _ramda.assoc)('query');

var createBreakpointMapping = exports.createBreakpointMapping = (0, _ramda.curry)(function (name, value, query) {
  return {
    name: name,
    query: query,
    value: value
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/breakpointMapping.js
// module id = 134
// module chunks = 168707334958949